import React, { SyntheticEvent, useEffect } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';

import {
  getAddressSearchError,
  getAddressSearchSuggestions,
  getAddressSearchValue,
  isAddressSearchDisabled,
  PersonModel,
} from '../../../../selectors/addressUnmodeled';
import { FIAS_LEVEL_HOUSE } from '../../../../constants/address';
import AddressSuggest, {
  AddressSuggestProps,
} from '../AddressSuggest/AddressSuggest';
import { addressValidationError, sendStats } from '../../../../helpers/stats';
import { SPECIAL_VALUE } from '../../../../helpers/address';

const AddressSearch = (props: AddressSuggestProps) => {
  const { error, disabled } = props;

  useEffect(() => {
    if (error && !disabled) {
      sendStats(addressValidationError('address_suggests'));
    }
  }, [error]);
  return <AddressSuggest {...props} />;
};

interface DispatchProps {
  onInputChange(value, method, event): void;
  setFromSuggest(value): void;
}

const mapStateToProps = createStructuredSelector({
  value: getAddressSearchValue,
  error: getAddressSearchError,
  disabled: isAddressSearchDisabled,
  suggestions: getAddressSearchSuggestions,
});

function mapDispatchToProps(
  dispatch: Dispatch,
  { model }: { model: PersonModel }
): DispatchProps {
  return {
    onInputChange(address, method, event: SyntheticEvent<HTMLInputElement>) {
      const { special } = address;
      if (special && Object.values(SPECIAL_VALUE).includes(special)) {
        return;
      }
      if (['click', 'enter'].includes(method)) {
        if (address.fias_level === FIAS_LEVEL_HOUSE) return;
        event.persist();
        const addressString =
          typeof address === 'string' ? address : address.address;
        dispatch({
          type: `${model}/address/fetch`,
          payload: addressString + ' ',
        });
        event.preventDefault();
        return;
      }
      if (['up', 'down'].includes(method)) {
        if (typeof address === 'string') {
          dispatch({ type: `${model}/address/change`, payload: { address } });
          return;
        }
        dispatch({
          type: `${model}/address/change`,
          payload: { address: address.address },
        });
        return;
      }
      if (method !== 'type') {
        dispatch({ type: `${model}/address/fetch`, payload: address.address });
        return;
      }
      dispatch({ type: `${model}/address/fetch`, payload: address });
    },
    setFromSuggest(payload) {
      dispatch({ type: `${model}/address/set`, payload });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressSearch);
